import React from 'react';
import	{useNavigate} from 'react-router-dom';
import PostAction from './PostAction';
import Avatar from '@mui/material/Avatar';

export default function PostFeed(){
	let navigate = useNavigate();
	
	const date = new Date();
	
	return(
		<>
		<section className="post-container" >
			<Avatar className="post-user-img" alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{ width: 50, height: 50 }} />
			<article className="post-feed" onClick={() => {navigate('/post')}}>
					<div className="post-feed-user-info" >
						<h3>Infi</h3>
						<h5>@infi</h5>
					</div>
					<p>The end and the beginning is one thing ^^, Scary right?
					The end and the beginning is one thing ^^, Scary right?</p>
					<img alt="post img" src="https://source.unsplash.com/random/girl" />
					<PostAction />
			</article>
		</section>
		</>
	);
}